export default __webpack_public_path__ + "static/media/play.54e558df.svg";